import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    Grid, Menu, Breadcrumb, Tab, Label, Icon
} from 'semantic-ui-react'
import ShowroomList from './ShowrromList';


function Showrrom() {
    let panes = [
        {
            menuItem: <Menu.Item key='TABpendente'>Showroom</Menu.Item>,
            render: () => <ShowroomList />
        },
    ]


    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Showroom</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling>
                    <Grid.Column>
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            </div>


            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                    

                .ui.breadcrumb .active.section {
                    background-color: #1884af !important;
                    color: #fff !important;
                }
            `}</style>

        </div>
    );
}


const mapStateToProps = (state) => ({
    // assistencias: state.AssistenciaReducer.assistencia
})


export default withRouter(connect(mapStateToProps, {
}
)(Showrrom));